module.exports = __webpack_public_path__ + "static/media/ic_report_outlined.21f3ee28.svg";